export default "assets/images/icons/marker-5f5e5856.svg";